import {Center, Image, StackProps, Text, VStack} from "@chakra-ui/react";
import emptyStateImage from "../../../assets/images/empty-state-wine.png";
import React from "react";
import {CircularProgress} from "@mui/material";

export const EmptyPage = ({title, isLoading, description, stackProps}: {isLoading?: boolean, title: string, description: string, stackProps?: StackProps}) => {
    return isLoading ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
            <CircularProgress color={"primary"}/>
        </div> : <Center h="full" {...stackProps}>
        <VStack spacing={4}>
            <Image src={emptyStateImage} w={368}/>
            <Text fontSize={20} color={"primary.400"} fontWeight="bold">{title}</Text>
            <Text>{description}</Text>
        </VStack>
    </Center>
}
